module.exports = __webpack_public_path__ + "img/icon_mywallet_black.0df291ff.svg";